import { render, staticRenderFns } from "./FieldLessonVideoInfo.vue?vue&type=template&id=3878a313&"
import script from "./FieldLessonVideoInfo.vue?vue&type=script&lang=ts&"
export * from "./FieldLessonVideoInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FieldLessonVideoInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports